export const orderStatus: { [key: number]: string } = {
  1: 'requested',
  2: 'confirmed',
  3: 'picking_up',
  4: 'ongoing_service',
  5: 'delivering',
  6: 'finished',
  12: 'assigned',

};
